import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import AdsAudienceLink from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceLink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdsAudienceMembershipActionExplainer({
  actionMetadata: {
    audienceId,
    shouldAdd
  }
}) {
  const messageKey = shouldAdd ? 'automation-ui-action-features.action-features.ads-audience-membership.summary.shouldAdd' : 'automation-ui-action-features.action-features.ads-audience-membership.summary.shouldRemove';
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: messageKey,
    options: {
      audienceLink: /*#__PURE__*/_jsx(AdsAudienceLink, {
        id: audienceId
      })
    }
  });
}